<template>
  <a-drawer
    :title="'资产卡片详情：' + (card.assetName || '')"
    :width="960"
    :visible="visible"
    :body-style="{ paddingBottom: '24px' }"
    @close="close">
    <a-spin :spinning="loading">
      <!-- 基本信息 -->
      <a-descriptions title="基本信息" :column="3" size="small" bordered style="margin-bottom: 16px;">
        <a-descriptions-item label="资产编码">{{ card.assetCode || '-' }}</a-descriptions-item>
        <a-descriptions-item label="资产名称">{{ card.assetName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="规格型号">{{ card.assetModel || '-' }}</a-descriptions-item>
        <a-descriptions-item label="资产类别">{{ card.categoryName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="折旧政策">{{ card.policyName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="状态">{{ card.status || '-' }}</a-descriptions-item>
        <a-descriptions-item label="资产原值">{{ fmt(card.originalValue) }}</a-descriptions-item>
        <a-descriptions-item label="月折旧额">{{ fmt(card.monthlyDepreciation) }}</a-descriptions-item>
        <a-descriptions-item label="残值率">{{ card.residualRate == null ? '-' : (Number(card.residualRate) * 100).toFixed(2) + '%' }}</a-descriptions-item>
        <a-descriptions-item label="使用年限(月)">{{ card.serviceLife == null ? '-' : card.serviceLife }}</a-descriptions-item>
        <a-descriptions-item label="已提月数">{{ card.depMonths == null ? '-' : card.depMonths }}</a-descriptions-item>
        <a-descriptions-item label="启用日期">{{ card.startDate || '-' }}</a-descriptions-item>
        <a-descriptions-item label="累计折旧">{{ fmt(card.accumulatedDepreciation) }}</a-descriptions-item>
        <a-descriptions-item label="减值准备">{{ fmt(card.impairmentAmount) }}</a-descriptions-item>
        <a-descriptions-item label="净值">{{ fmt(card.netValue) }}</a-descriptions-item>
        <a-descriptions-item label="期初累计折旧">{{ fmt(card.initialAccumDep) }}</a-descriptions-item>
        <a-descriptions-item label="存放地点">{{ card.location || '-' }}</a-descriptions-item>
        <a-descriptions-item label="保管人">{{ card.responsiblePerson || '-' }}</a-descriptions-item>
        <a-descriptions-item label="折旧费用科目">{{ card.depExpenseCode || '-' }}</a-descriptions-item>
        <a-descriptions-item label="税法年限(月)">{{ card.taxLifeMonths == null ? '-' : card.taxLifeMonths }}</a-descriptions-item>
        <a-descriptions-item label="一次性扣除">{{ card.taxOneOff === '1' ? '是' : '否' }}</a-descriptions-item>
        <a-descriptions-item label="转固单号">{{ card.transBillNo || '-' }}</a-descriptions-item>
        <a-descriptions-item label="来源单号">{{ card.sourceBillNo || '-' }}</a-descriptions-item>
        <a-descriptions-item label="备注" :span="3">{{ card.remark || '-' }}</a-descriptions-item>
      </a-descriptions>

      <a-tabs v-model="activeTab" @change="onTabChange">
        <!-- 折旧明细 -->
        <a-tab-pane key="dep" tab="折旧明细">
          <a-table bordered size="small" rowKey="id" :columns="depColumns" :dataSource="depRows"
            :loading="depLoading" :pagination="depPagination" @change="onDepPageChange" />
        </a-tab-pane>
        <!-- 变动历史 -->
        <a-tab-pane key="change" tab="变动历史">
          <a-table bordered size="small" rowKey="id" :columns="changeColumns" :dataSource="changeRows"
            :loading="changeLoading" :pagination="changePagination" @change="onChangePageChange" />
        </a-tab-pane>
        <!-- 维修记录 -->
        <a-tab-pane key="repair" tab="维修记录">
          <a-table bordered size="small" rowKey="id" :columns="repairColumns" :dataSource="repairRows"
            :loading="repairLoading" :pagination="repairPagination" @change="onRepairPageChange" />
        </a-tab-pane>
        <!-- 附件 -->
        <a-tab-pane key="attachment" tab="附件">
          <div style="margin-bottom: 12px;">
            <a-select v-model="uploadType" style="width: 120px; margin-right: 8px;">
              <a-select-option value="照片">照片</a-select-option>
              <a-select-option value="铭牌">铭牌</a-select-option>
              <a-select-option value="存放位置">存放位置</a-select-option>
              <a-select-option value="其他">其他</a-select-option>
            </a-select>
            <a-upload :showUploadList="false" :beforeUpload="beforeUpload" accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf">
              <a-button type="primary" icon="upload" :loading="uploading">上传附件</a-button>
            </a-upload>
          </div>
          <a-table bordered size="small" rowKey="id" :columns="attachColumns" :dataSource="attachRows" :loading="attachLoading" :pagination="false">
            <template slot="attachAction" slot-scope="text, record">
              <a @click="previewAttachment(record)">预览</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除该附件?" @confirm="() => deleteAttachment(record)">
                <a style="color: red;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import { assetGet, assetDepreciationList, assetChangeLogList, repairListByAsset,
  attachmentList, attachmentUpload, attachmentView, attachmentDelete } from './api/fixedAsset'

export default {
  name: 'AssetCardDetail',
  data() {
    return {
      visible: false,
      loading: false,
      card: {},
      activeTab: 'dep',
      // 折旧明细
      depRows: [], depLoading: false,
      depPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showTotal: (t) => `共 ${t} 条` },
      // 变动历史
      changeRows: [], changeLoading: false,
      changePagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showTotal: (t) => `共 ${t} 条` },
      // 维修记录
      repairRows: [], repairLoading: false,
      repairPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showTotal: (t) => `共 ${t} 条` },
      // 附件
      uploadType: '照片', uploading: false,
      attachRows: [], attachLoading: false,
      depColumns: [
        { title: '期间', customRender: (t, r) => (r.depYear ? r.depYear + '-' + String(r.depMonth).padStart(2, '0') : (r.depreciationPeriod || '-')) },
        { title: '本期折旧额', dataIndex: 'depreciationAmount', align: 'right' },
        { title: '累计折旧', dataIndex: 'accumulatedDepreciation', align: 'right' },
        { title: '净值', dataIndex: 'netValue', align: 'right' },
        { title: '计提单ID', dataIndex: 'billId', width: 100 },
        { title: '创建时间', customRender: (t, r) => this.fmtTime(r.createdTime) }
      ],
      changeColumns: [
        { title: '变动类型', dataIndex: 'changeType', width: 100 },
        { title: '字段', dataIndex: 'fieldName', width: 130 },
        { title: '旧值', dataIndex: 'oldValue', ellipsis: true },
        { title: '新值', dataIndex: 'newValue', ellipsis: true },
        { title: '操作人', dataIndex: 'operator', width: 90 },
        { title: '时间', customRender: (t, r) => this.fmtTime(r.operateTime) }
      ],
      repairColumns: [
        { title: '维修单号', dataIndex: 'billNo', width: 140 },
        { title: '维修类型', dataIndex: 'repairType', width: 100 },
        { title: '维修内容', dataIndex: 'repairContent', ellipsis: true },
        { title: '金额', dataIndex: 'amount', align: 'right', width: 100 },
        { title: '日期', customRender: (t, r) => this.fmtTime(r.billTime) },
        { title: '状态', dataIndex: 'status', width: 80 }
      ],
      attachColumns: [
        { title: '附件类型', dataIndex: 'attachType', width: 100 },
        { title: '文件名', dataIndex: 'fileName', ellipsis: true },
        { title: '操作', dataIndex: 'attachAction', width: 130, scopedSlots: { customRender: 'attachAction' } }
      ]
    }
  },
  methods: {
    moment,
    fmt(v) { return v == null ? '-' : Number(v).toFixed(2) },
    fmtTime(v) { return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : '-' },
    show(record) {
      this.visible = true
      this.card = { ...record }
      this.activeTab = 'dep'
      this.loadCard()
      this.loadDep()
    },
    close() { this.visible = false },
    loadCard() {
      if (!this.card.id) return
      this.loading = true
      assetGet(this.card.id).then((res) => {
        if (res && res.success && res.data) this.card = res.data
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    onTabChange(key) {
      if (key === 'dep') this.loadDep()
      else if (key === 'change') this.loadChange()
      else if (key === 'repair') this.loadRepair()
      else if (key === 'attachment') this.loadAttach()
    },
    // ==================== 折旧明细 ====================
    loadDep() {
      if (!this.card.id) return
      this.depLoading = true
      assetDepreciationList(this.card.id, {
        page: this.depPagination.current, pageSize: this.depPagination.pageSize
      }).then((res) => {
        if (res && res.success && res.data) {
          this.depRows = res.data.records || []
          this.depPagination.total = res.data.total || 0
        }
        this.depLoading = false
      }).catch(() => { this.depLoading = false })
    },
    onDepPageChange(p) { this.depPagination.current = p.current; this.depPagination.pageSize = p.pageSize; this.loadDep() },
    // ==================== 变动历史 ====================
    loadChange() {
      if (!this.card.id) return
      this.changeLoading = true
      assetChangeLogList(this.card.id, {
        page: this.changePagination.current, pageSize: this.changePagination.pageSize
      }).then((res) => {
        if (res && res.success && res.data) {
          this.changeRows = res.data.records || []
          this.changePagination.total = res.data.total || 0
        }
        this.changeLoading = false
      }).catch(() => { this.changeLoading = false })
    },
    onChangePageChange(p) { this.changePagination.current = p.current; this.changePagination.pageSize = p.pageSize; this.loadChange() },
    // ==================== 维修记录 ====================
    loadRepair() {
      if (!this.card.id) return
      this.repairLoading = true
      repairListByAsset({
        assetId: this.card.id, page: this.repairPagination.current, pageSize: this.repairPagination.pageSize
      }).then((res) => {
        if (res && res.success && res.data) {
          this.repairRows = res.data.records || []
          this.repairPagination.total = res.data.total || 0
        }
        this.repairLoading = false
      }).catch(() => { this.repairLoading = false })
    },
    onRepairPageChange(p) { this.repairPagination.current = p.current; this.repairPagination.pageSize = p.pageSize; this.loadRepair() },
    // ==================== 附件 ====================
    loadAttach() {
      if (!this.card.id) return
      this.attachLoading = true
      attachmentList(this.card.id).then((res) => {
        if (res && res.success) this.attachRows = res.data || []
        this.attachLoading = false
      }).catch(() => { this.attachLoading = false })
    },
    beforeUpload(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('附件大小不能超过 10MB')
        return false
      }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('attachType', this.uploadType)
      this.uploading = true
      attachmentUpload(this.card.id, formData).then((res) => {
        this.uploading = false
        if (res && res.success) {
          this.$message.success('上传成功')
          this.loadAttach()
        } else {
          this.$message.error((res && res.message) || '上传失败')
        }
      }).catch(() => {
        this.uploading = false
        this.$message.error('上传失败')
      })
      return false
    },
    previewAttachment(record) {
      attachmentView(record.id).then((res) => {
        const blob = new Blob([res.data], { type: (res.headers && res.headers['content-type']) || 'application/octet-stream' })
        const url = window.URL.createObjectURL(blob)
        window.open(url)
      }).catch(() => { this.$message.error('预览失败') })
    },
    deleteAttachment(record) {
      attachmentDelete(record.id).then((res) => {
        if (res && res.success) {
          this.$message.success('删除成功')
          this.loadAttach()
        } else {
          this.$message.error((res && res.message) || '删除失败')
        }
      })
    }
  }
}
</script>
